"use strict";

type LinkPreviewPayload = { url: string; title: string; description?: string; image?: string | null; siteName?: string };

var ChatLinkPreview = (function () {
  const URL_RE = /https?:\/\/[^\s<>"']+/i;
  const YOUTUBE_VIDEO_ID_RE = /^[A-Za-z0-9_-]{11}$/;
  function firstUrl(text: string): string | null {
    const match = String(text || "").match(URL_RE);
    return match ? match[0].replace(/[),.!?]+$/, "") : null;
  }
  function youtubeVideoId(rawUrl: string): string | null {
    try {
      const url = new URL(rawUrl);
      const hostname = url.hostname.toLowerCase().replace(/^www\./, "");
      let candidate = "";
      if (hostname === "youtu.be") candidate = url.pathname.split("/").filter(Boolean)[0] || "";
      if (["youtube.com", "m.youtube.com", "music.youtube.com"].includes(hostname)) {
        candidate = url.pathname === "/watch"
          ? url.searchParams.get("v") || ""
          : (/^\/(?:embed|shorts|live|v)\/([^/]+)/.exec(url.pathname)?.[1] || "");
      }
      return YOUTUBE_VIDEO_ID_RE.test(candidate) ? candidate : null;
    } catch {
      return null;
    }
  }
  function appendYoutube(content: HTMLElement, url: string, videoId: string): void {
    const card = document.createElement("div");
    card.className = "link-preview-card link-preview-youtube";
    const play = document.createElement("button");
    play.className = "link-preview-youtube-play";
    play.type = "button";
    play.setAttribute("aria-label", "YouTube 동영상 재생");
    const image = document.createElement("img");
    image.className = "link-preview-youtube-thumbnail";
    image.src = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
    image.alt = "";
    image.loading = "lazy";
    image.referrerPolicy = "no-referrer";
    const icon = document.createElement("span");
    icon.className = "link-preview-youtube-icon";
    icon.setAttribute("aria-hidden", "true");
    play.append(image, icon);
    play.addEventListener("click", () => {
      const iframe = document.createElement("iframe");
      iframe.className = "link-preview-youtube-frame";
      iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`;
      iframe.title = "YouTube 동영상";
      iframe.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share";
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = "strict-origin-when-cross-origin";
      card.replaceChildren(iframe);
    }, { once: true });
    const source = document.createElement("a");
    source.className = "link-preview-youtube-source";
    source.href = url;
    source.target = "_blank";
    source.rel = "noopener noreferrer";
    source.textContent = "YouTube에서 열기";
    card.append(play, source);
    const time = content.querySelector(".message-time");
    content.insertBefore(card, time || null);
  }
  function append(message: HTMLElement | null, text: string): void {
    const url = firstUrl(text);
    if (!url || !message) return;
    const content = message.querySelector<HTMLElement>(".message-content");
    if (!content || content.querySelector(".link-preview-card")) return;
    const videoId = youtubeVideoId(url);
    if (videoId) {
      appendYoutube(content, url, videoId);
      return;
    }
    const messageEl = message;
    void fetch("/api/link-preview?url=" + encodeURIComponent(url))
      .then((response) => response.ok ? response.json() : Promise.reject(new Error("preview unavailable")))
      .then((body: { preview?: LinkPreviewPayload }) => {
        const preview = body.preview;
        if (!preview || typeof preview.url !== "string" || typeof preview.title !== "string" || !messageEl.isConnected) return;
        const card = document.createElement("a");
        card.className = "link-preview-card";
        card.href = preview.url;
        card.target = "_blank";
        card.rel = "noopener noreferrer";
        const copy = document.createElement("span");
        copy.className = "link-preview-copy";
        const site = document.createElement("span"); site.className = "link-preview-site"; site.textContent = preview.siteName || new URL(preview.url).hostname;
        const title = document.createElement("strong"); title.className = "link-preview-title"; title.textContent = preview.title;
        copy.append(site, title);
        if (preview.description) { const description = document.createElement("span"); description.className = "link-preview-description"; description.textContent = preview.description; copy.appendChild(description); }
        card.appendChild(copy);
        if (preview.image) { const image = document.createElement("img"); image.className = "link-preview-image"; image.src = preview.image; image.alt = ""; image.loading = "lazy"; image.referrerPolicy = "no-referrer"; image.addEventListener("error", () => image.remove()); card.prepend(image); }
        const time = content.querySelector(".message-time");
        content.insertBefore(card, time || null);
      }).catch(() => { /* 원문 링크는 그대로 유지하고 프리뷰만 생략한다. */ });
  }
  return { append, firstUrl, youtubeVideoId };
})();
